import Filters from "../components/Filters/Filters";
import InstantSearchWrapper from "../components/layout/Search/InstantSearchWrapper";
import MainHits from "../components/Hits/MainHits";
import Search from "../components/Search/Search";
import Pagination from "../components/Pagination/Pagination";
import CategoryFilters from "../components/Filters/CategoryFilters/CategoryFilters";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";

interface SearchResultsProps {
    indexName: string;
}
export default function SearchResults({indexName}: SearchResultsProps) {

    const [searchParams] = useSearchParams();
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedCount, setSelectedCount] = useState(0);

    return (
        <div className="fl-container__flex">
            <InstantSearchWrapper indexName={indexName}>
                <div className={"fl-container__flex fl-container__flex--gap"} style={{ paddingTop: "20px", backgroundColor: "white" }}>
                    <Search />
                    <div className={"fl-container__content search-page__results-for-container"}>
                        <p className={"search-page__results-for"}>Search results for <i>{searchParams.get("query") ? decodeURI(searchParams.get("query")!) : ""}</i></p>
                    </div>
                    <CategoryFilters setSelectedCategory={(category) => setSelectedCategory(category)} setSelectedCount={(count) => setSelectedCount(count)}/>            
                </div>
                <div className={"fl-container__content fl-container__flex fl-container__flex--gap"} style={{ paddingTop: "20px" }}>
                    <Filters />
                    <div className={"search-page__number-results"}>{selectedCount.toString()} {selectedCategory === "All" && window.steelcase_i18n["steelcase-finish-library"].all ? window.steelcase_i18n["steelcase-finish-library"].all : selectedCategory }</div>
                    <MainHits />
                    <Pagination />
                </div>
            </InstantSearchWrapper>
        </div>
    )
}